import { Route, Routes, useLocation } from "react-router-dom";

import Tabs from "@/components/Tabs";
import useStore from "@/services/store";
import ApiAnnonceur from "./ApiAnnonceur";
import Flux from "./Flux";
import RealTime from "./RealTime";
import TrackingAnnounce from "./TrackingAnnounce";
import TrackingBroadcast from "./TrackingBroadcast";

const Settings = () => {
  const { flux, publisher } = useStore();
  const publisherId = publisher?.id;
  const location = useLocation();
  const currentRoute = location.pathname.split("/settings")[1].replace("/", "");
  const tabs = [
    {
      key: "flux",
      label: "Flux de missions",
      route: "",
      isActive: currentRoute === "",
    },
    {
      key: "api",
      label: "Flux API",
      route: "api",
      isActive: currentRoute === "api",
    },
    {
      key: "tracking",
      label: "Tracking des événements",
      route: "tracking",
      isActive: currentRoute === "tracking",
    },
    {
      key: "real-time",
      label: "Événements en temps réel",
      route: "real-time",
      isActive: currentRoute === "real-time",
    },
  ].map((tab) => ({
    ...tab,
    id: `settings-tab-${tab.key}`,
    to: `/${publisherId}/settings/${tab.route}`,
  }));
  const activeTab = tabs.find((tab) => tab.isActive) || tabs[0];
  const activeTabId = activeTab ? activeTab.id : null;

  if (flux === "from") {
    const fromTabs = [
      {
        key: "tracking",
        label: "Paramètres de tracking",
        route: "",
        isActive: currentRoute !== "real-time",
      },
      {
        key: "real-time",
        label: "Événements en temps réel",
        route: "real-time",
        isActive: currentRoute === "real-time",
      },
    ].map((tab) => ({
      ...tab,
      id: `settings-tab-${tab.key}`,
      to: `/${publisherId}/settings/${tab.route}`,
    }));
    const activeFromTab = fromTabs.find((tab) => tab.isActive) || fromTabs[0];

    return (
      <div className="space-y-12">
        <title>API Engagement - Paramètres de tracking</title>
        <h1 className="text-4xl font-bold">Paramètres</h1>
        <div>
          <Tabs tabs={fromTabs} ariaLabel="Paramètres" panelId="settings-panel" className="flex items-center gap-4 pl-4 font-semibold text-black" variant="primary" />
          <section id="settings-panel" role="tabpanel" aria-labelledby={activeFromTab?.id} className="bg-white shadow-lg">
            <Routes>
              <Route path="/" element={<TrackingBroadcast />} />
              <Route path="/real-time" element={<RealTime />} />
            </Routes>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-12">
      <h1 className="text-4xl font-bold">Paramètres</h1>
      <div>
        <Tabs tabs={tabs} ariaLabel="Paramètres" panelId="settings-panel" className="flex items-center gap-4 pl-4 font-semibold text-black" variant="primary" />
        <section id="settings-panel" role="tabpanel" aria-labelledby={activeTabId || undefined} className="bg-white shadow-lg">
          <Routes>
            <Route path="/" element={<Flux />} />
            <Route path="/api" element={<ApiAnnonceur />} />
            <Route path="/tracking" element={<TrackingAnnounce />} />
            <Route path="/real-time" element={<RealTime />} />
          </Routes>
        </section>
      </div>
    </div>
  );
};

export default Settings;
